var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiles = function SvgFiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 124,
    viewBox: "0 0 108 124"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-1",
    x1: "0%",
    x2: "100%",
    y1: "50.001%",
    y2: "50.001%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-2",
    x1: "0%",
    x2: "100%",
    y1: "50.001%",
    y2: "50.001%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-3",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-4",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-5",
    x1: "50%",
    x2: "50%",
    y1: "99.994%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-6",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-7",
    x1: "0%",
    x2: "100%",
    y1: "49.981%",
    y2: "49.981%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-8",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-9",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-10",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-11",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-12",
    x1: "0%",
    x2: "100.006%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-13",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-14",
    x1: "0%",
    x2: "100%",
    y1: "49.997%",
    y2: "49.997%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-15",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-16",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-17",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-18",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-19",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-20",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-21",
    x1: "0%",
    x2: "100.031%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-22",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-23",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-24",
    x1: "0%",
    x2: "100%",
    y1: "49.996%",
    y2: "49.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-25",
    x1: "50.007%",
    x2: "50.007%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-26",
    x1: "0%",
    x2: "100%",
    y1: "50.008%",
    y2: "50.008%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-27",
    x1: "50.017%",
    x2: "50.017%",
    y1: "99.899%",
    y2: "-.151%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-28",
    x1: "0%",
    x2: "100.037%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-29",
    x1: ".089%",
    x2: "100%",
    y1: "50.127%",
    y2: "50.127%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-30",
    x1: "0%",
    x2: "100.04%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-31",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-32",
    x1: "50.011%",
    x2: "50.011%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-33",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-34",
    x1: "0%",
    x2: "100%",
    y1: "49.969%",
    y2: "49.969%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-35",
    x1: "0%",
    x2: "99.987%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-36",
    x1: "0%",
    x2: "99.982%",
    y1: "49.845%",
    y2: "49.845%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-37",
    x1: "0%",
    x2: "100%",
    y1: "49.845%",
    y2: "49.845%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-38",
    x1: "0%",
    x2: "100%",
    y1: "49.845%",
    y2: "49.845%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-39",
    x1: "0%",
    x2: "99.982%",
    y1: "50.155%",
    y2: "50.155%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-40",
    x1: "0%",
    x2: "100%",
    y1: "50.155%",
    y2: "50.155%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-41",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-42",
    x1: "0%",
    x2: "99.991%",
    y1: "49.994%",
    y2: "49.994%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-43",
    x1: "0%",
    x2: "99.991%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-44",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-45",
    x1: "0%",
    x2: "100%",
    y1: "49.875%",
    y2: "49.875%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-46",
    x1: "0%",
    x2: "100%",
    y1: "50.125%",
    y2: "50.125%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-47",
    x1: "0%",
    x2: "100%",
    y1: "49.875%",
    y2: "49.875%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-48",
    x1: "0%",
    x2: "100%",
    y1: "50.125%",
    y2: "50.125%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-49",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-50",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-51",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-52",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-53",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-54",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-55",
    x1: "50.006%",
    x2: "50.006%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-56",
    x1: "50.003%",
    x2: "50.003%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-57",
    x1: "50.013%",
    x2: "50.013%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-58",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-59",
    x1: "49.983%",
    x2: "49.983%",
    y1: "100.203%",
    y2: ".254%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-60",
    x1: "49.983%",
    x2: "49.983%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-61",
    x1: "50.005%",
    x2: "50.005%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "files_svg__linearGradient-62",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "files_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    opacity: 0.238
  }, /*#__PURE__*/React.createElement("g", {
    id: "files_svg__export",
    fillRule: "nonzero",
    transform: "translate(-102 -341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "files_svg__files",
    transform: "translate(102 339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "files_svg__undraw_collecting_fjjl-(4)",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "files_svg__Group",
    opacity: 0.7,
    transform: "translate(0 26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-1)",
    d: "M121.524 47.144 73.168 35.615v90.234l48.356-12.532z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-1)",
    d: "M48.43 11.555.074.025V90.26L48.43 77.728z",
    opacity: 0.1,
    transform: "translate(73.094 35.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-2)",
    d: "m24.81 47.144 48.358-11.529v90.234L24.81 113.566z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-2)",
    d: "M.046 11.555 48.404.025V90.26L.046 77.977z",
    opacity: 0.17,
    transform: "translate(24.764 35.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-3)",
    d: "m73.168 35.615 25.064-20.553 48.356 12.283-25.064 19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-4)",
    d: "m0 27.594 24.81 19.55 48.358-11.529L48.61 15.062z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-4)",
    d: "m0 12.567 24.81 19.55L73.168 20.59 48.61.036z",
    opacity: 0.05,
    transform: "translate(0 15.027)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 35.892,
    height: 32.786,
    x: 0.156,
    y: 0.075,
    fill: "url(#files_svg__linearGradient-5)",
    opacity: 0.5,
    rx: 4.5,
    transform: "translate(37.146 25.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 35.065,
    height: 31.991,
    x: 37.739,
    y: 25.439,
    fill: "url(#files_svg__linearGradient-6)",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 5.913,
    height: 5.269,
    x: 40.442,
    y: 30.708,
    fill: "url(#files_svg__linearGradient-7)",
    rx: 2.635
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 23.508,
    height: 1,
    x: 48.128,
    y: 30.708,
    fill: "url(#files_svg__linearGradient-8)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 23.508,
    height: 1,
    x: 48.128,
    y: 32.464,
    fill: "url(#files_svg__linearGradient-8)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 31.786,
    height: 1,
    x: 39.85,
    y: 38.84,
    fill: "url(#files_svg__linearGradient-9)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 31.786,
    height: 1,
    x: 39.85,
    y: 40.596,
    fill: "url(#files_svg__linearGradient-9)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 31.786,
    height: 1,
    x: 39.85,
    y: 42.937,
    fill: "url(#files_svg__linearGradient-9)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 18.332,
    height: 1,
    x: 39.85,
    y: 44.695,
    fill: "url(#files_svg__linearGradient-10)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 31.786,
    height: 1,
    x: 39.85,
    y: 47.03,
    fill: "url(#files_svg__linearGradient-9)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 31.786,
    height: 1,
    x: 39.85,
    y: 48.785,
    fill: "url(#files_svg__linearGradient-9)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 31.786,
    height: 1,
    x: 39.85,
    y: 51.128,
    fill: "url(#files_svg__linearGradient-9)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 18.332,
    height: 1,
    x: 39.85,
    y: 52.884,
    fill: "url(#files_svg__linearGradient-10)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 35.892,
    height: 32.786,
    x: 0.18,
    y: 0.136,
    fill: "url(#files_svg__linearGradient-11)",
    opacity: 0.5,
    rx: 4.5,
    transform: "translate(42.539 32.624)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 35.065,
    height: 31.991,
    x: 43.156,
    y: 33.015,
    fill: "url(#files_svg__linearGradient-6)",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 5.913,
    height: 5.269,
    x: 45.858,
    y: 38.285,
    fill: "url(#files_svg__linearGradient-7)",
    rx: 2.635
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 23.508,
    height: 1,
    x: 53.547,
    y: 38.285,
    fill: "url(#files_svg__linearGradient-8)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 23.508,
    height: 1,
    x: 53.547,
    y: 40.04,
    fill: "url(#files_svg__linearGradient-8)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 31.786,
    height: 1,
    x: 45.267,
    y: 46.415,
    fill: "url(#files_svg__linearGradient-12)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 31.786,
    height: 1,
    x: 45.267,
    y: 48.173,
    fill: "url(#files_svg__linearGradient-12)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 31.786,
    height: 1,
    x: 45.267,
    y: 50.514,
    fill: "url(#files_svg__linearGradient-12)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 18.332,
    height: 1,
    x: 45.267,
    y: 52.269,
    fill: "url(#files_svg__linearGradient-10)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 31.786,
    height: 1,
    x: 45.267,
    y: 54.606,
    fill: "url(#files_svg__linearGradient-12)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 31.786,
    height: 1,
    x: 45.267,
    y: 56.362,
    fill: "url(#files_svg__linearGradient-12)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 31.786,
    height: 1,
    x: 45.267,
    y: 58.705,
    fill: "url(#files_svg__linearGradient-12)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 18.332,
    height: 1,
    x: 45.267,
    y: 60.461,
    fill: "url(#files_svg__linearGradient-10)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-13)",
    d: "M.082.03h31.099v36.175H.082z",
    opacity: 0.5,
    transform: "translate(63.508 36.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-14)",
    d: "M64.547 37.587h29.481V72.38H64.547z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Shape",
    fill: "url(#files_svg__linearGradient-15)",
    d: "M5.602 1.004V.13H2.397v.874H.142v4.293H7.85V1.004zM2.796.444h2.396V1H2.796z",
    opacity: 0.5,
    transform: "translate(75.291 42.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-16)",
    d: "M75.759 43.263h7.058v3.931h-7.058z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-17)",
    d: "M77.818 42.462v1.02h.367v-.727h2.205v.728h.367v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-18)",
    d: "M68.958 52.851H89.69v1H68.958zM68.958 58.6H89.69v1H68.958zM68.958 60.129H89.69v1H68.958z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-19)",
    d: "M68.958 57.072h8.749v1h-8.749z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-20)",
    d: "M.068.129h6.543v1H.068z",
    opacity: 0.6,
    transform: "translate(83.08 56.943)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-21)",
    d: "M76.236 63.696h6.543v1h-6.543z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-22)",
    d: "M24.81 47.144v66.422l48.358 12.283v-65.92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-23)",
    d: "M121.524 113.317 73.168 125.85v-65.92l48.356-12.785z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-23)",
    d: "M48.43 66.26.074 78.791v-65.92L48.43.088z",
    opacity: 0.07,
    transform: "translate(73.094 47.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-24)",
    d: "M.03 5.45v21.806l19.242-5.264V.186z",
    opacity: 0.07,
    transform: "translate(102.252 85.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-25)",
    d: "M96.217 41.604h14.261V55.17H96.217z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-26)",
    d: "M96.441 41.936h13.814v12.957H96.441z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Shape",
    fill: "url(#files_svg__linearGradient-27)",
    d: "M4.314.71V.05H1.87v.664H.16V3.98h5.865V.71zM2.177.287H4.01V.71H2.177z",
    opacity: 0.5,
    transform: "translate(100.255 43.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-28)",
    d: "M.008.03h5.368v2.99H.008z",
    opacity: 0.6,
    transform: "translate(100.655 44.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-29)",
    d: "M.176.012v.777h.281V.235h1.678V.79h.28V.012z",
    opacity: 0.6,
    transform: "translate(102.053 43.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-30)",
    d: "M.116.006h4.977v1H.116z",
    opacity: 0.6,
    transform: "translate(100.854 49.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-31)",
    d: "M99.097 50.852h8.502v1h-8.502z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-32)",
    d: "M.098.136h18.477v15.027H.098z",
    opacity: 0.5,
    transform: "translate(62.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-33)",
    d: "M62.624.421h18.012v14.493H62.624z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-34)",
    d: "M62.624.421h18.012v3.233H62.624z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-34)",
    d: "M.114.026h18.012v3.233H.114z",
    opacity: 0.1,
    transform: "translate(62.51 .395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-35)",
    d: "M64.059 4.826h15.142v1.882H64.059z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-36)",
    d: "M64.059 8.13h11.052v1H64.059z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-37)",
    d: "M64.059 9.232h7.176v1h-7.176z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-38)",
    d: "M64.059 10.333h9.472v1h-9.472z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-39)",
    d: "M64.059 11.432h11.052v1H64.059z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-40)",
    d: "M64.059 12.533h3.695v1h-3.695z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-41)",
    d: "M.104.15h22.903v18.623H.104z",
    opacity: 0.5,
    transform: "translate(89.47 11.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-42)",
    d: "M89.842 11.772h22.326v17.963H89.842z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-43)",
    d: "M89.842 11.772h22.326v4.006H89.842z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-44)",
    d: "M91.62 17.231h18.767v2.333H91.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-45)",
    d: "M91.62 21.326h13.698v1H91.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-46)",
    d: "M91.62 22.69h8.895v1H91.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-47)",
    d: "M91.62 24.057h11.741v1H91.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-45)",
    d: "M91.62 25.421h13.698v1H91.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-48)",
    d: "M91.62 26.785h4.581v1H91.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-49)",
    d: "M92.598 18.024h5.336v1h-5.336z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-50)",
    d: "m.014 33.76 27.089 6.769 21.772-17.546V12.205L.52.174z",
    opacity: 0.1,
    transform: "translate(24.165 47.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-51)",
    d: "M49.01 33.76 21.917 40.53.146 22.983V12.205L48.502.174z",
    opacity: 0.1,
    transform: "translate(72.895 47.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-52)",
    d: "M24.81 47.144 0 67.448 48.356 79.48l24.812-19.551z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-53)",
    d: "m121.524 47.144 25.064 20.304L98.486 79.48 73.168 59.929z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "url(#files_svg__linearGradient-53)",
    d: "m48.43.087 25.064 20.304L25.39 32.422.074 12.872z",
    opacity: 0.07,
    transform: "translate(73.094 47.057)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "#535461",
    d: "M121 73.373 73 62v89l48-12.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "#000",
    d: "M121 73.373 73 62v89l48-12.36z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "#535461",
    d: "M26 73.373 74 62v89l-48-12.115z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "#000",
    d: "M26 72.45 74 61v90l-48-12.197z",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "#BEBEBE",
    d: "M73 60.64 98.528 40 147 52.1 121.472 72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "#BEBEBE",
    d: "M2 53.109 26.416 72 74 60.859 49.834 41z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "files_svg__Group",
    fill: "url(#files_svg__linearGradient-54)",
    opacity: 0.5,
    transform: "translate(38 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 35.636,
    height: 33.876,
    x: 0.166,
    y: 0.049,
    rx: 4.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 35,
    height: 31,
    x: 39,
    y: 52,
    fill: "#F5F5F5",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 6,
    height: 6,
    x: 41,
    y: 56,
    fill: "#145ECC",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 23,
    height: 1,
    x: 49,
    y: 56,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 23,
    height: 1,
    x: 49,
    y: 57,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 32,
    height: 1,
    x: 40,
    y: 64,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 32,
    height: 1,
    x: 40,
    y: 66,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 32,
    height: 1,
    x: 40,
    y: 68,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 18,
    height: 1,
    x: 41,
    y: 69,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 32,
    height: 1,
    x: 40,
    y: 72,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 32,
    height: 1,
    x: 40,
    y: 74,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 32,
    height: 1,
    x: 40,
    y: 76,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 18,
    height: 1,
    x: 41,
    y: 77,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "files_svg__Group",
    fill: "url(#files_svg__linearGradient-55)",
    opacity: 0.5,
    transform: "translate(43 57)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 35.835,
    height: 33.876,
    x: 0.145,
    y: 0.047,
    rx: 4.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 35,
    height: 31,
    x: 44,
    y: 58,
    fill: "#FFF",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 6,
    height: 6,
    x: 47,
    y: 63,
    fill: "#145ECC",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 23,
    height: 1,
    x: 54,
    y: 64,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 23,
    height: 1,
    x: 54,
    y: 65,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 32,
    height: 1,
    x: 46,
    y: 72,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 32,
    height: 1,
    x: 46,
    y: 73,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 32,
    height: 1,
    x: 46,
    y: 76,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 18,
    height: 1,
    x: 47,
    y: 77,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 32,
    height: 1,
    x: 46,
    y: 79,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 32,
    height: 1,
    x: 46,
    y: 82,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 32,
    height: 1,
    x: 46,
    y: 84,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "files_svg__Rectangle",
    width: 18,
    height: 1,
    x: 47,
    y: 85,
    fill: "#E0E0E0",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "files_svg__Group",
    fill: "url(#files_svg__linearGradient-56)",
    opacity: 0.5,
    transform: "translate(65 61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    d: "M.066.104h29.882V36.98H.066z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#FFF",
    d: "M66 62h29v35H66z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "files_svg__Group",
    fill: "url(#files_svg__linearGradient-57)",
    opacity: 0.5,
    transform: "translate(76 67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Shape",
    d: "M5.588 1.149V.173H2.316v.976H.026v4.784h7.85V1.15zM2.716.529h2.461v.62H2.716z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#145ECC",
    d: "M77 69h7v3h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "#145ECC",
    d: "M78 67v1h.25v-.714h1.5V68H80v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#E0E0E0",
    d: "M69 77h21v1H69zM69 84h21v1H69zM69 85h21v1H69zM69 82h9v1h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#3AD29F",
    d: "M83 82h7v1h-7z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#145ECC",
    d: "M77 88h7v1h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "#BEBEBE",
    d: "M26 73v65.827L74.347 151 75 85.669z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "#BEBEBE",
    d: "M121 138.58 73 151V85.669L121 73z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "#BEBEBE",
    d: "M102 115.251V137l19-5.25V110z",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-58)",
    d: "M97 67h14v13H97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#F5F5F5",
    d: "M97 67h13v13H97z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "files_svg__Group",
    fill: "url(#files_svg__linearGradient-59)",
    opacity: 0.5,
    transform: "translate(101 69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Shape",
    d: "M4.156.545V.036H1.73V.54H.032v2.456h5.822V.545zM2.034.226h1.82v.317h-1.82z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#145ECC",
    d: "M100 69h6v2h-6z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "#145ECC",
    d: "M103 68v1h.25v-.715h1.501V69H105v-1z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "files_svg__Group",
    fill: "#145ECC",
    opacity: 0.6,
    transform: "translate(100 75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    d: "M.21.168h5.702v1H.21z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#BDBDBD",
    d: "M99 76h9v1h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "url(#files_svg__linearGradient-58)",
    d: "M84 0h14v13H84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#F5F5F5",
    d: "M84 0h13v13H84z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "files_svg__Group",
    fill: "url(#files_svg__linearGradient-60)",
    opacity: 0.5,
    transform: "translate(87 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Shape",
    d: "M4.182.579V.103H1.756v.476H.058v2.34H5.88V.579zM2.06.276h1.82v.303H2.06z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#145ECC",
    d: "M87 3h6v2h-6z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "#145ECC",
    d: "M89 2v1h.25v-.715h1.501V3H91V2z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "files_svg__Group",
    fill: "#145ECC",
    opacity: 0.6,
    transform: "translate(88 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    d: "M.01.065h5.93v1H.01z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#BDBDBD",
    d: "M86 9h9v1h-9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "files_svg__Group",
    fill: "url(#files_svg__linearGradient-61)",
    opacity: 0.5,
    transform: "translate(63 25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    d: "M.091.126h17.754v14.872H.091z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#F2F2F2",
    d: "M63 25h18v15H63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#145ECC",
    d: "M63 26h18v3H63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#000",
    d: "M63 26h18v3H63z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#E0E0E0",
    d: "M65 30h14v2H65zM65 32h11v1H65zM64 35h7v1h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#E0E0E0",
    d: "M65 35h10v1H65zM65 36h11v1H65zM65 37h4v1h-4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "files_svg__Group",
    fill: "url(#files_svg__linearGradient-62)",
    opacity: 0.5,
    transform: "translate(90 36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    d: "M.063.044h21.751v18.877H.063z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#FFF",
    d: "M90 37h22v18H90z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#145ECC",
    d: "M90 37h22v3H90z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#F5F5F5",
    d: "M92 43h18v2H92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#E0E0E0",
    d: "M92 47h13v1H92zM92 48h9v1h-9zM91 49h12v1H91zM92 50h13v1H92zM92 51h4v1h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Rectangle",
    fill: "#69F0AE",
    d: "M92 42h6v1h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "#000",
    d: "M25 106.293 52.165 113 74 95.608V84.926L25.507 73zM123 106.293 95.835 113 74 95.608V84.926L122.493 73z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "files_svg__Path",
    fill: "#BEBEBE",
    d: "M25.416 72 1 92.093 48.584 104 73 84.652zM121.42 72 146 92.093 98.828 104 74 84.652z"
  })))))));
};
export default SvgFiles;